import React, { useRef, useState, Suspense, lazy } from "react";
import { withStyles } from "@material-ui/core";
import { Navigate } from "react-router-dom";
import { AppLoading } from "../../../loaders/loaders";
import styles from "../moduleViewstyles";
import { withUserProfile } from "../../../userProfile/userProfileContext";
import { compose } from "recompose";
import appConstant from "../../../appConstants";
import { RMAXLogger } from "../../../services/LoggerService/RMAXLogger";
import ReportList from "./ReportList";
import { withFeatureFlags } from "../../../userProfile/featureFlagsContext";
import { withAppConfig } from "../../../appConfigContext";
const DockCompliance = lazy(() => import("./DockCompliance"));
const IBPlanningSummary = lazy(() => import("./IBPlanningSummary/index"));
const ProHistory = lazy(() => import("./ProHistory/ProHistoryGrid"));
const KPISummary = lazy(() => import("./KPISummary/index"));
const DuplicateCustomers = lazy(() => import("./DuplicateCustomers/index"));
const ShipmentsEventStream = lazy(() => import("./ShipmentsEventStream"));
const NextStopComplianceReports = lazy(() =>
  import("./NextStopCompliance/index")
);
const TrailerStripPriorityReport = lazy(() =>
  import("./TrailerStripPriority")
);
const DriverPerformanceHistoricReport = lazy(() =>
  import("./DriverPerformance/HistoricReport/FilterFormPage")
);
const RecordsLookup = lazy(()=>
  import("./RecordsLookup/index")
)

const UsageReport = lazy(()=>import("./UsageReport/index"))

const MergedCustomersReport = lazy(()=>import("./MergedCustomers"))

const RouteAuditReport = lazy(()=>import("./RouteAudit/index"))

const Reports = (props) => {
  const [showReportsList, setReportList] = useState(true);
  const enableNextStopComplianceReportRef = useRef(
    props.featureFlags.isFeatureEnabled(appConstant.features.EnableNextStopComplianceReport)
  );

  const enableDriverPerformanceHistoricReportRef = useRef(
    props.featureFlags.isFeatureEnabled(appConstant.features.EnableDriverPerformanceHistoricReport)
  );

  const enableIBStripPriorityReportRef = useRef(
    props.featureFlags.isFeatureEnabled(appConstant.features.EnableIBStripPriorityReport)
  );

  // Client level feature flags
  const { enableRouteAudit } = props.configJSON;

  const getSubComponentModule = () => {
    //Log Telemetry
    const userProfile = props.userData.userProfile;
    const { isAdmin } = userProfile;
    RMAXLogger.info("ReportsView", { report: props.path });
    const { NAV_URLS } = appConstant;
    switch (props.path) {
      case NAV_URLS.REPORT_IBPSUMMARY:
        return isAdmin ? (
          <IBPlanningSummary />
        ) : (
          <Navigate to={appConstant.NAV_URLS.ACCESS_DENIED} />
        );
      case NAV_URLS.REPORT_PRO_HISTORY:
        return <ProHistory />;
      case NAV_URLS.REPORT_DOCK_COMPLIANCE:
        return isAdmin ? (
          <DockCompliance />
        ) : (
          <Navigate to={appConstant.NAV_URLS.ACCESS_DENIED} />
        );
      case NAV_URLS.REPORT_KPI_SUMMARY:
        return <KPISummary />;
      case NAV_URLS.NEXT_STOP_COMPLIANCE:
        return enableNextStopComplianceReportRef.current ? (
          <NextStopComplianceReports
            hideReportsListItem={hideReportsListItem}
          />
        ) : (
          <Navigate to={appConstant.NAV_URLS.ACCESS_DENIED} />
        );
      case NAV_URLS.REPORT_DUPLICATE_CUSTOMERS:
        return <DuplicateCustomers glEventHub={props.glEventHub} />;
      case NAV_URLS.REPORT_MERGED_CUSTOMERS:
        return <MergedCustomersReport glEventHub={props.glEventHub} />;
      case NAV_URLS.REPORT_TRAILER_STRIP_PRIORITY:
        return enableIBStripPriorityReportRef.current ? (
          <TrailerStripPriorityReport
            glEventHub={props.glEventHub}
            hideReportsListItem={hideReportsListItem}
          />
        ) : (
          <Navigate to={appConstant.NAV_URLS.ACCESS_DENIED} />
        );
      case NAV_URLS.REPORT_DRIVER_PERFORMANCE:
        return enableDriverPerformanceHistoricReportRef.current ? (
          <DriverPerformanceHistoricReport/>
        ) : (
          <Navigate to={appConstant.NAV_URLS.ACCESS_DENIED} />
        );
      case NAV_URLS.REPORT_SHIPMENTS_EVENT_STREAM:
        return <ShipmentsEventStream />;
      case NAV_URLS.REPORT_RECORDS_lOOKUP:
         return  props.configJSON.enableRecordsLookupReport ? 
         <RecordsLookup glEventHub={props.glEventHub} /> 
         : <Navigate to={appConstant.NAV_URLS.ACCESS_DENIED} />
      case NAV_URLS.REPORT_USAGE_REPORT:
        return isAdmin ? <UsageReport /> : <Navigate to={appConstant.NAV_URLS.ACCESS_DENIED} />;
      case NAV_URLS.REPORT_ROUTE_AUDIT:
        return enableRouteAudit ? (
          <RouteAuditReport />
        ) : (
          <Navigate to={appConstant.NAV_URLS.ACCESS_DENIED} />
        );
      default:
        return <>URL not found</>;
    }
  };

  const hideReportsListItem = (value) => {
    setReportList(value);
  };

  const { classes } = props;
  const moduleStyleClasses = showReportsList
    ? `${classes.rightSection} ${classes.reportsRightSection} ${classes.extraPadding}`
    : `${classes.reportsFullSection} ${classes.fullSection} ${classes.extraPadding}`;
  return (
    <div className={classes.settingsContainer}>
      {showReportsList && (
        <header className={classes.settingsModuleHeader}>Reports</header>
      )}
      <div className={classes.settingsModuleContent}>
        {showReportsList && (
          <ReportList
            activeModule={props.path}
            enableNextStopComplianceReport={enableNextStopComplianceReportRef.current}
            enableDriverPerformanceHistoricReport={enableDriverPerformanceHistoricReportRef.current}
            enableRecordsLookupReport={props.configJSON.enableRecordsLookupReport}
            enableIBStripPriorityReport={enableIBStripPriorityReportRef.current}
            enableRouteAudit={enableRouteAudit}
          />
        )}
        <div className={moduleStyleClasses}>
          <Suspense fallback={<AppLoading />}>
            {getSubComponentModule()}
          </Suspense>
        </div>
      </div>
    </div>
  );
}

export default compose(
  withStyles(styles),
  withUserProfile,
  withFeatureFlags,
  withAppConfig
)(Reports);
